import React from 'react'
import moment from 'moment'

// components
import {
  CRow,
  CCol,
  CFormLabel,
  CFormText
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'
import FormEmployeeEducation from 'src/components/form/general-input-form/FormEmployeeEducation'
import FormEmployeeAccount from 'src/components/form/general-input-form/FormEmployeeAccount'
import AppImageDetail from '../general-details/AppImageDetails'
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'

// helpers
import { capitalizeFirstLetter } from 'src/helpers/text-format'
import { getFileType } from 'src/helpers/get-file-type'

const AppDetails = ({
  employeeDetails,
  handleViewFile
}) => {
  let projectAssigned = employeeDetails.employee_assignments?.length > 0 ? employeeDetails.employee_assignments?.map((item) => item?.label) : []
  let files = []
  let fileType = ''
  if (employeeDetails?.npwp_original_name) {
    fileType = getFileType(employeeDetails?.npwp_original_name)
    files = [
      {
        file_url: employeeDetails?.npwp_url,
        file_original_name: employeeDetails?.npwp_original_name
      }
    ]
  }
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="First name"
          className='mb-3'
          subtitle={employeeDetails?.first_name}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Last name"
          className='mb-3'
          subtitle={employeeDetails?.last_name}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Email address"
          className='mb-3'
          subtitle={employeeDetails?.email_address}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Employee No"
          className='mb-3'
          subtitle={employeeDetails?.employee_no ? employeeDetails?.employee_no : '-'}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Place of Birth"
          className='mb-3'
          subtitle={employeeDetails?.place_of_birth ? capitalizeFirstLetter(employeeDetails?.place_of_birth) : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Date of Birth"
          className='mb-3'
          subtitle={employeeDetails?.date_of_birth ? moment(employeeDetails?.date_of_birth).format('DD/MM/YYYY') : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Gender"
          className='mb-3'
          subtitle={employeeDetails?.gender ? capitalizeFirstLetter(employeeDetails?.gender) : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Status Contract"
          className='mb-3'
          subtitle={employeeDetails?.status ? capitalizeFirstLetter(employeeDetails?.status) : '-'}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Contact Number"
          className='mb-3'
          subtitle={`${employeeDetails?.country?.phone_code}${employeeDetails?.contact_number}`}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Contract Start Date"
          className='mb-3'
          subtitle={employeeDetails?.contract_start_date ? moment(employeeDetails?.contract_start_date).format('DD/MM/YYYY') : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Contract End Date"
          className='mb-3'
          subtitle={employeeDetails?.contract_end_date ? moment(employeeDetails?.contract_end_date).format('DD/MM/YYYY') : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Job Title/Position"
          className='mb-3'
          subtitle={employeeDetails?.job_title ? employeeDetails?.job_title : '-'}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Address"
          className='mb-3'
          subtitle={employeeDetails?.address}
        />
        <AppTextColumnDetails
          colSize="3"
          title="NIK"
          className='mb-3'
          subtitle={employeeDetails?.nik}
        />
        <AppTextColumnDetails
          colSize="3"
          title="BPJS KIS"
          className='mb-3'
          subtitle={employeeDetails?.bpjs_kis_no ? employeeDetails?.bpjs_kis_no : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Status Employee"
          className='mb-3'
          subtitle={employeeDetails?.is_active === true ? 'Active' : 'Inactive'}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Project Assignment"
          className='mb-3'
          subtitle={projectAssigned?.length > 0 ? projectAssigned.join(', ') : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Employement Date"
          className='mb-3'
          subtitle={employeeDetails?.register_date ? `${moment(employeeDetails?.register_date).format('DD MMMM YYYY')} (${moment().diff(employeeDetails?.register_date, 'days')} days)` : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Notes"
          className='mb-3'
          subtitle={employeeDetails?.notes ? employeeDetails?.notes : '-'}
        />
      </CRow>
      <CRow className='mb-4'>
        {
          fileType === 'image' ? (
            <AppImageDetail
              colSize="6"
              title="Document NPWP"
              images={employeeDetails?.npwp_url}
              handleViewFile={handleViewFile}
            />
          ) : (
            <CCol lg={6}>
              <CFormLabel>
                Document NPWP
              </CFormLabel>
              {
                files?.length > 0 ? (
                  <FormFileThumbnail 
                    name='npwp_image'
                    colSize='6'
                    files={files}
                    className='justify-content-start align-items-center'
                    handleViewFile={handleViewFile}
                    isDetailPage={true}
                  />
                ) : (
                  <CFormText>
                    -
                  </CFormText>
                )
              }
            </CCol>
          )
        }
      </CRow>
      <CRow>
        {
          employeeDetails?.educations?.length > 0 ? (
            <FormEmployeeEducation 
              colSize='12'
              className='mb-3'
              inputLabel='Employee Education'
              employeeEducations={employeeDetails?.educations}
              disabled={true}
            />
          ) : (
            <AppTextColumnDetails
              colSize="3"
              title="Employee Education"
              className='mb-4'
              subtitle={'-'}
            />
          )
        }
      </CRow>
      <CRow>
        {
          employeeDetails?.accounts?.length > 0 ? (
            <FormEmployeeAccount 
              colSize='12'
              className='mb-4'
              inputLabel='Employee Account'
              employeeAccounts={employeeDetails?.accounts}
              disabled={true}
            />
          ) : (
            <AppTextColumnDetails
              colSize="3"
              title="Employee Account"
              className='mb-4'
              subtitle={'-'}
            />
          )
        }
      </CRow>
    </>
  )
}

export default AppDetails
